package com.wsa.hawebapp

import androidx.compose.ui.Modifier.Companion.then
import kotlinx.coroutines.await
import kotlin.js.Promise

private external val navigator: dynamic

actual fun isBluetoothAvailable(): Boolean =
    js("typeof navigator !== 'undefined' && !!navigator.bluetooth") as Boolean

actual suspend fun requestBleDevice(): BleDevice? {
    if (!isBluetoothAvailable()) return null
    return try {
        val options: dynamic = js("({ acceptAllDevices: true, optionalServices: [] })")
        val device = (navigator.bluetooth.requestDevice(options) as Promise<dynamic>).await()
        if (device.name != null)
        BleDevice(
            id   = (device.id   as? String) ?: "unknown-id",
            name = (device.name as? String) ?: "Unknown Device"
        ) else null
    } catch (e: dynamic) {
        null
    }
}

actual suspend fun getBondedDevices(): List<BleDevice> {
    if (!isBluetoothAvailable()) return emptyList()
    return try {
        val jsDevices = (navigator.bluetooth.getDevices() as Promise<dynamic>).await()
        val length = jsDevices.length as Int
        (0 until length).mapNotNull { i ->
            val d = jsDevices[i]
            val name = d.name as? String ?: return@mapNotNull null
            BleDevice(
                id   = (d.id as? String) ?: "unknown-id",
                name = name
            )
        }
    } catch (e: dynamic) {
        emptyList()
    }
}